import {
  loadCropsDetails,
  loadExistingEquipment,
  loadNewlyAddedEquipmentDetails,
  loadExpenseDetails,
} from './digidiary.service';
import {getContractsArray, getCustomerId} from './selectors';

import {postAPICall} from '../../services/apiCallsHandler';
import {
  DD_PUT_MY_FARM_DATA,
  SET_UP_HOME_PAGE,
  SET_UP_HOME_PAGE_loading,
  UPDATE_POPUP_SEEN_REQUEST,
} from '../actions';
import {updateWhatsAppOptInDetailsAction} from '../actions/actions';
import {setExpenseTypes} from '../actions/digiDiaryActions';

import {all, call, put, select, takeEvery} from 'redux-saga/effects';

export function* loadHomePageData() {
  let myFarmLoading = true;
  yield put({type: SET_UP_HOME_PAGE_loading, myFarmLoading});
  // yield put({type: SET_UP_HOME_PAGE_min_info_loading, myFarmMinInfoLoading: true});
  const customerId = yield select(getCustomerId);
  let loadCrops = [];

  loadCrops = yield loadCropsDetails(customerId);
  if (loadCrops && loadCrops.data) {
    const cropId = loadCrops.data[0].cropId;
    const loadExpenses = yield loadExpenseDetails(customerId, cropId);

    const dataObjReady = {
      crops: loadCrops?.data,
    };
    let totalIncome = loadExpenses?.data.filter(
      (item) => item.type == 'totalIncome'
    );
    totalIncome = totalIncome?.length > 0 ? totalIncome[0].total : 0;
    yield put(setExpenseTypes({field: 'totalIncome', value: totalIncome}));
    yield put({type: DD_PUT_MY_FARM_DATA, dataObj: dataObjReady});
    yield put(
      setExpenseTypes({field: 'expenseTypesData', value: loadExpenses.data})
    );

    const newlyAddedEquipmentDetails = yield loadNewlyAddedEquipmentDetails(
      customerId
    );
    const contractsArray = yield select(getContractsArray);
    const existingEquipment = yield all(
      contractsArray?.map((contracts) =>
        loadExistingEquipment(customerId, contracts.contractNumber)
      )
    );

    const dataObj = {
      crops: loadCrops?.data,
      equipments: newlyAddedEquipmentDetails?.data,
      existingEquipments: existingEquipment,
    };
  }

  myFarmLoading = false;
  yield put({type: SET_UP_HOME_PAGE_loading, myFarmLoading});
}

export function* setHomePageView() {
  yield takeEvery(SET_UP_HOME_PAGE, loadHomePageData);
}

export function* updatePopupSeenSaga() {
  const customerId = yield select(getCustomerId);
  const url = `${process.env.REACT_APP_CONTRACT_DETAILS_EXPERIENCE_API}whatsappOptin?customerId=${customerId}&type=update-popup`;
  yield call(postAPICall, url, {}, {errorTag: 'update-popup-seen-api'});
  yield put(updateWhatsAppOptInDetailsAction({isUpdatePopupSeen: true}));
}

export function* updatePopupSeenWatcher() {
  yield takeEvery(UPDATE_POPUP_SEEN_REQUEST, updatePopupSeenSaga);
}
